import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getPlantsByClient = async (page:number, uniqueCode: string) => {
    try{
        const response = await axios.get(`${API_BASE_URL}/plants/client/${uniqueCode}`, { params: {page, size: 10}, withCredentials: true});
        return {
            plants: response.data.data.plants.content,
            page: response.data.data.plants.number,
            totalPages: response.data.data.plants.totalPages,
        };
    }
    catch(error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al buscar plantas.');
        } else if (error.request) {
            throw new Error('No se puede conectar al servidor.');
        } else {
            throw new Error(error.message || 'Error inesperado.');
        }
    }
}

export const updatePlantById = async (plantDTO: any) => {
    try{
        const response = await axios.put(`${API_BASE_URL}/plants/${plantDTO.id}`, plantDTO , {withCredentials: true});
    }
    catch(error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al actualizar planta.');
        } else if (error.request) {
            throw new Error('No se puede conectar al servidor.');
        } else {
            throw new Error(error.message || 'Error inesperado.');
        }
    }
}

export const createPlant = async (plantDTO: any) => {
    try{
        return await axios.post(`${API_BASE_URL}/plants`, plantDTO, {withCredentials: true});
    }
    catch(error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al actualizar planta.');
        } else if (error.request) {
            throw new Error('No se puede conectar al servidor.');
        } else {
            throw new Error(error.message || 'Error inesperado.');
        }
    }
}